import { type ScoreEntity, type WhereGroup, isWhereGroup, whereField } from '@parcel/filters';
import type { NewCriterion } from './criteria-state.js';

/**
 * An Ask answer as criteria at Important: each rule on the record itself is its own criterion, rules on one
 * linked record stay one criterion (the same record), and any group or "any of"/"not" answer is one custom criterion.
 */
export function criteriaFromAsk(entity: ScoreEntity, where: WhereGroup): NewCriterion[] {
  const one = (w: WhereGroup): NewCriterion => ({ impact: 'important', where: w });
  if (where.combinator !== 'and' || where.not) return where.rules.length ? [one(where)] : [];
  const out: NewCriterion[] = [];
  const byRelation = new Map<string, WhereGroup['rules']>();
  for (const node of where.rules) {
    if (isWhereGroup(node)) {
      out.push(one({ combinator: 'and', rules: [node] }));
      continue;
    }
    const relation = whereField(entity, node.field)?.relation;
    if (!relation) {
      out.push(one({ combinator: 'and', rules: [node] }));
      continue;
    }
    if (!byRelation.has(relation)) {
      const rules: WhereGroup['rules'] = [];
      byRelation.set(relation, rules);
      out.push(one({ combinator: 'and', rules }));
    }
    byRelation.get(relation)?.push(node);
  }
  return out;
}
